var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.293 5.21a1 1 0 1 1 1.414 1.414l-6.293 6.293 6.293 6.293.069.076a1 1 0 0 1-1.407 1.406l-.076-.068L12 14.331l-6.293 6.293a1 1 0 0 1-1.414-1.414l6.293-6.293-6.293-6.293-.068-.076A1 1 0 0 1 5.63 5.142l.076.068L12 11.503z"
  })));
};
export default Svg24;